import {
  NgModule
} from '@angular/core';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {
  GridModule
} from '@progress/kendo-angular-grid';
import {
  DateInputsModule
} from '@progress/kendo-angular-dateinputs';
import {
  DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import {
  InputsModule
} from '@progress/kendo-angular-inputs';

import {
  SharedCommonModule
} from '../shared/common';
import {
  LoadingIndicatorModule
} from '../shared/layout/components/loading-indicator/loading-indicator.module';
import {BreadcrumbModule} from '../shared/layout/components/breadcrumb/breadcrumb.module';
import {DistributorAccountsComponent} from './distributor-accounts.component';
import {DistributorAccountsService} from './distributor-accounts.service';

@NgModule({
  declarations: [
    DistributorAccountsComponent
  ],
  imports: [
    ButtonsModule,
    GridModule,
    DateInputsModule,
    DropDownsModule,
    InputsModule,
    LoadingIndicatorModule,
    BreadcrumbModule,
    SharedCommonModule
  ],
  providers: [
    DistributorAccountsService
  ]
})
export class DistributorAccountsModule {
}
